// @ts-nocheck
import { flow, Instance, types } from 'mobx-state-tree';
import { getBaseStore } from './BaseStore';
import { getEnvironment } from './utils';
import { Message } from './models/Message';
import { Sending } from './models/Sending';

export const MessageSearchCriteria = types.model({
  secretariatId: types.maybeNull(types.number),
  pharmacyId: types.maybeNull(types.number),
});

export const SendingEventExtSearchCriteria = types.model({
  secretariatId: types.maybeNull(types.number),
  pharmacyId: types.maybeNull(types.number),
});

export const SendingStore = types
  .compose(
    getBaseStore<Instance<typeof Sending>, Instance<typeof Sending>>(Sending, 'sendingId', 'sending'),
    types.model('SendingStore', {}),
  )
  .actions((self) => {
    const env = getEnvironment(self);
    const apiFetcher = env.api;

    // const updateMessageInStore = (msg: Instance<typeof Message>) => {
    //   const msgModel = Message.create(msg);
    //   self.datas.put(msgModel);
    //   return msgModel;
    // };

    // const searchSendingEventExt = flow(function*(criteria: Instance<typeof SendingEventExtSearch>) {
    //   const result = yield apiFetcher.get('message/history', {
    //     params: criteria,
    //   });
    //   const resultMsg: Array<Instance<typeof SendingEventExt>> = [];
    //   // @ts-ignore
    //   result.forEach((node) => {
    //     const createdMsg = updateMessageInStore(node);
    //     resultMsg.push(createdMsg);
    //   });
    //   return resultMsg;
    // });
    const search = flow(function*(criteria: Instance<typeof SendingSearchCriteria>) {
      const result = yield apiFetcher.get('sending', {
        params: criteria,
      });
      const sendings: Array<Instance<typeof Sending>> = [];
      // @ts-ignore
      result.forEach((node) => {
        const createdSending = updateMessageInStore(node);
        sendings.push(createdSending);
      });
      return result;
    });

    const sendPreview = flow(function*(data: any) {
      try {
        const res = yield env.api.post('message/Preview/withContent', data);
        if ((res as any).length !== 0) {
          // @ts-ignore
          updateMessageInStore(res);
          return true;
        }
        return false;
      } catch (error) {
        return false;
      }
    });

    return { search };
  });

export type SendingStoreType = Instance<typeof SendingStore>;
